import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'

const InfoCardSkeleton = () => {
  return (
    <div className="flex flex-row gap-6 rounded-md border p-4">
      <Skeleton className="size-12" />
      <div className="flex flex-col">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="mt-2 h-8 w-24" />
      </div>
    </div>
  )
}

const TransactionCardSkeleton = () => {
  return (
    <div className="relative flex h-auto w-full shrink-0 flex-col border-t py-8">
      <Skeleton className="h-8 w-64" />
      <Skeleton className="mt-2 h-4 w-32" />
      <div className="group relative">
        <div className="mt-4 flex w-full flex-row gap-2 overflow-x-auto pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <InfoCardSkeleton />
          <InfoCardSkeleton />
          <InfoCardSkeleton />
        </div>
      </div>
    </div>
  )
}

export default TransactionCardSkeleton
